import React from 'react';
import { Box, LucideIcon } from '@skin-seoul/design-system';
interface CategorySliderNavigationButtonProps {
  direction: 'left' | 'right';
  onClick: () => void;
  ariaLabel: string;
}
const CategorySliderNavigationButton = ({
  direction,
  onClick,
  ariaLabel
}: CategorySliderNavigationButtonProps) => {
  const isLeft = direction === 'left';
  return <Box as="button" width="108px" height="108px" borderRadius="50%" backgroundColor="generic.0" display="flex" alignItems="center" justifyContent="center" cursor="pointer" transition="background-color 0.2s" onClick={onClick} _hover={{
    backgroundColor: 'primary.75'
  }} aria-label={ariaLabel} border="none" data-sentry-element="Box" data-sentry-component="CategorySliderNavigationButton" data-sentry-source-file="CategorySliderNavigationButton.tsx">
      <LucideIcon name={isLeft ? 'ChevronLeft' : 'ChevronRight'} boxSize="24px" color="neutral.700" strokeWidth={1} data-sentry-element="LucideIcon" data-sentry-source-file="CategorySliderNavigationButton.tsx" />
    </Box>;
};
export default CategorySliderNavigationButton;